import {Type} from 'class-transformer';
import {ValueListItem} from "../../../core/_datamodel/common";

export class CosoPrompt {
  coso_prompts_id: number | undefined;
  id_user: number | undefined;
  // @ts-ignore
  @Type(() => Date)
  c_date: Date | undefined;
  category: string | undefined;
  title: string | undefined;
  prompt: string | undefined;
  flag_public = false;
  userDisplay: string | undefined;

  get idDisplay() {
    return `#${this.coso_prompts_id}`;
  }

  get visibilityDisplay() {
    return this.flag_public ? 'Public' : 'Private';
  }

  get visibilitySeverity(): any {
    return this.flag_public ? 'success' : 'secondary';
  }
}

export type CosoPromptVisibilityFilter = 'all' | 'public' | 'private';

export const COSO_PROMPT_VISIBILITY_VALUELIST: ValueListItem[] = [
  {label: 'All', value: 'all'},
  {label: 'Public', value: 'public'},
  {label: 'Private', value: 'private'},
];
